import {FieldDefinition} from '@shared/models/field-definition';
/**
 * Created by jahidul.hasan on 11/3/2019.
 */
export class FieldSectionSelectionModel {
   public id: string;
   public surveyId: string;
   public sourceType: string;
   public sectionHeader: string;
   public toolName: string;
   public isSelected: string;
   constructor(data?: any) {
   if (data) {
     Object.assign(this, data);
   }
   }
}

export class WorksheetFieldInfo {
  public WorksheetName: string;
  public StartColumnIndex: number;
  public EndColumnIndex: number;
  public ColumnHeaderRowIndex: number;
  public StartDataRowIndex: number;
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
    }
}

export class EditSurveyQuestionDialogModel {
  public questionDetails: FieldDefinition;
  public selectedSection: any;
  public disableDataTypeEdit: boolean;
  public hideSettings: boolean;
  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    } else {
      this.hideSettings = true;
      this.disableDataTypeEdit = true;
    }
  }
}
export class FlowChartNode {
  id: string;
  questionId: string;
  copyId: string;
  sourceSectionId: string;
  questionDisplayId: string;
  title: string;
  isMandatory: boolean;
  fieldType: string;
  conditionDisplayText: string;
  children: FlowChartNode[];
  order: number;
  isHidden: boolean;
  isParentHidden: boolean;
  hasFormulaExpression: boolean;
  useFormula: boolean;
  fieldValues: any;
  dataType: string;
  fieldKey: string;
  hasQualifyingSurvey: boolean;
  isChecked: boolean;
  isCustom: boolean;
}
export class FlowChartUiFlatNode {
  constructor(
    public expandable: boolean,
    public level: number,
    public id: string,
    public item: any,
  ) {}
}

export class VisibilityLogicGate {
  public visibilityType: string;
  public fieldLogicGates: any[];
}

export interface ExternalItem {
  IsSelected: boolean;
  FieldKey: string;
  ExternalKey: string;
  Header: string;
}



